import { Entity, OpacityComponent } from '@aninix-inc/model'
import { INode } from 'svgson'

export const applyOpacity = (entity: Entity, node: INode) => {
  const opacity = parseFloat(node.attributes.opacity)
  if (!opacity) return

  entity.updateComponent(OpacityComponent, opacity)
}
